// client/src/components/ServicesArea.js
import React, { useState } from 'react';
import { STRAPI_CMS_URL } from '../utils/Utils.js';
import { useServices } from '../utils/fetchContent';
import LoadingSpinner from './LoadingSpinner.js';

function ServicesArea() {
    
    const services = useServices();
    const [hoveredService, setHoveredService] = useState(null);

    if (!services) {
        return <LoadingSpinner message={"Lade Funktionen..."} />;
    }

    return (
        <section className="inner-services-area pb-100">
            <div className="container">
                <div className="inner-services-item-wrap">
                    <div className="row justify-content-center">
                        {services.map((service, index) => (
                        <div className="col-xl-3 col-lg-4 col-md-6 col-sm-8 d-flex" key={index} onMouseEnter={() => setHoveredService(index)} onMouseLeave={() => setHoveredService(null)} style={{ position: "relative" }}>
                            <div className="services-item-four">
                                <div className="services-icon-four">
                                {!service.icon ? <div/> : <img src={STRAPI_CMS_URL + service.icon.url} alt=""/>}
                                </div>
                                <div className="services-content-four">
                                    <h2 className="title">{service.title}</h2>
                                    <p>{service.caption}</p>
                                </div>
                            </div>

                            {/* Popup image */}
                            {hoveredService === index && service.demoImage && (
                                <img
                                    src={STRAPI_CMS_URL + service.demoImage.url}
                                    alt={service.title || ""}
                                    className="popup-image"
                                    style={{
                                    top: "-220px",          // move above the card
                                    left: "50%",            // horizontal center relative to the card
                                    transform: "translateX(-50%)", // center horizontally
                                    }}
                                />
                            )}

                        </div>))}
                    </div>
                </div>
            </div>
        </section>        
)}

export default ServicesArea
